//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const hito = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/hito`,
    state: {
        Ahito: [],
        AIndicador:[]
    }
}).get({
    action: "Gethitos",   
    path: function (obj) {
        return `/indicador/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Ahito = payload.data;
    }
}).get({
    action: "gethitobyid",   
    path: function (obj) {
        return `/${obj.idhito}/indicador`;
    }, 
    onSuccess: (state, payload ) => {
        state.AIndicador = payload.data;
    }
}).put({
    action: "PostHito", 
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        state.Ahito.finalizar = false;
        store.dispatch("mensaje/set_error", error);
    }
})

.getStore();

hito.getters = {
    ghito: state => {
        return state.Ahito;
    },
    gindicadorhito: state => {
        return state.AIndicador;
    }
}

export default hito;